export default __webpack_public_path__ + "static/media/Return Fire.29880e32.png";